// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileSearchOutlinedSvg from "@fishx/icons-svg/es/asn/FileSearchOutlined";
import FishxIcon from '../components/FishxIcon';

var FileSearchOutlined = function FileSearchOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileSearchOutlinedSvg
  }));
};

FileSearchOutlined.displayName = 'FileSearchOutlined';
export default React.forwardRef(FileSearchOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileSearchOutlined.js
// module id = 2737
// module chunks = 0